import { getTheme } from "../../../graphic/theme";

import { GLYPH_NUMBER_TYPE } from "../../../graphic/constants";

export class DefaultCanvasGlyphRender {
    constructor() {
        this.numberType = GLYPH_NUMBER_TYPE;
    }
    reInit() {}
    drawShape(glyph, context, x, y, drawContext, params, fillCb, strokeCb) {
        drawContext.drawContribution && glyph.getSubGraphic().forEach((item => {
            const renderer = drawContext.drawContribution.getRenderContribution(item);
            renderer && renderer.drawShape && renderer.drawShape(item, context, x, y, drawContext, params, fillCb, strokeCb);
        }));
    }
    draw(glyph, renderService, drawContext, params) {
        const {context: context} = drawContext;
        if (!context) return;
        if (context.highPerformanceSave(), !drawContext.drawContribution) return;
        const glyphTheme = getTheme(glyph), subGraphic = glyph.getSubGraphic();
        subGraphic.length && subGraphic.forEach((g => {
            drawContext.drawContribution.renderItem(g, drawContext, {
                theme: glyphTheme
            });
        })), context.highPerformanceRestore();
    }
}
//# sourceMappingURL=glyph-render.js.map
